import React, {Component} from "react";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {SlideDown} from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import moment from 'moment';
import userImage from "../../assets/128x128.jpg";
import api from '../../utils/api';

/* global $ */

/**
 *
 */
class Sidebar extends Component {

    constructor(props){
        super(props);

        this.state = {
            sidebar: [
                // Categories
                {
                    title: "",
                    items: [
                        {
                            title: "Dashboard",
                            path: '/dashboard',
                            icon: 'ion ion-speedometer',
                            role: 'student'
                        },
                        {
                            title: "Dashboard",
                            path: '/admin',
                            icon: 'zmdi zmdi-trending-up',
                            role: 'instructor, admin'
                        },
                        {
                            title: "Dashboard (Legacy)",
                            path: '/dashboard-admin',
                            icon: 'ion ion-speedometer',
                            role: 'instructor, admin'
                        },

                        {
                            title: "Course Admin",
                            path: '/course-admin',
                            icon: 'zmdi zmdi-library',
                            role: 'admin'
                        },
                        {
                            title: "Course Syllabus",
                            icon: 'zmdi zmdi-library',
                            role: 'student'
                        },
                        {
                            title: 'Announcements',
                            path: '/chat/announcements',
                            icon: 'zmdi zmdi-portable-wifi',
                            role: 'student'
                        },

                        {
                            title: "Messages",
                            path: '/chat',
                            icon: 'zmdi zmdi-comment-text',
                            role: 'student'
                        },
                        {
                            title: "Messages",
                            path: '/chat/tickets',
                            icon: 'zmdi zmdi-comment-text',
                            role: 'instructor'
                        },
                        {
                            title: "Messages",
                            path: '/chat/admin/tickets',
                            icon: 'zmdi zmdi-comment-text',
                            role: 'admin'
                        },
                        {
                            title: "Tests",
                            path: '/tests',
                            icon: 'zmdi zmdi-file-text',
                            role: 'admin'
                        },
                        {
                            title: "Tests",
                            path: '/my-tests',
                            icon: 'zmdi zmdi-file-text',
                            role: 'student'
                        },
                    
                        {
                            title: "Reminders",
                            path: '/tasks',
                            icon: 'zmdi zmdi-alarm',
                            role: 'student'
                        },
                        {
                            title: "Settings",
                            path: '/settings',
                            icon: 'zmdi zmdi-settings'
                        },
                        {
                            title: "Users",
                            path: '/users/all',
                            icon: 'zmdi zmdi-account-circle',
                            role: 'admin'
                        },
                        {
                            title: "Logout",
                            path: '/login',
                            icon: 'fa fa-power-off'
                        }
                    ],
                }
            ]
        }
    }


    //LifecycleMethods
    componentWillMount() {
        this.props.onLoad();
    }

    getUserImage = () => {

        if(this.props.user) {
            if(this.props.profile.image){
                return api.makeFileURL(this.props.profile.image, this.props.user.id);
            }else{
                return userImage;
            }

        }
    }

    //Renders
    renderUserInfo = () => (
        <div className="user-panel">
            <div className="pull-left image">
                <Link to="/settings">
                <img
                    src={this.getUserImage()}
                    className=""
                    alt="User"
                />
                </Link>
            </div>
            <div className="pull-left info">
                <p>
                    {this.props.user.user.name || this.props.user.user.email }
                </p>
                <p className='text-info'>
                    {this.props.user.user.role}
                </p>

            </div>
        </div>
    );

    renderCategories = () => (
        this.state.sidebar.map((category, index) => {
            let shouldShow = true;
            if(category.hasOwnProperty("role") && category.role.indexOf(this.props.user.user.role) === -1){
                shouldShow = false;
            }

            if(shouldShow) {
                return (
                    <ul className="sidebar-menu" key={`category_${index}`}>
                        <li className="header">{category.title}</li>

                        {
                            category.items &&
                            this.renderCategoryItems(index, category.items)
                        }
                    </ul>
                )
            }else{
                return (null);
            }
        })
    );

    renderCategoryItems = (catId, items) => {
        return items.map((item, index) => {
            let shouldShow = true;
            if (item.hasOwnProperty("role") && item.role.indexOf(this.props.profile.role) === -1) {
                shouldShow = false;
            }

            if(item.title == "Profile"){
                item.path = "/student-profile/" + this.props.user.user.Profile.id;
            }

            let badgeIcon = null;
            
            if(item.title === "Announcements"){
                if(this.props.threads){
                    if(this.props.threads.filter(t => t.title === 'announcements').length > 0){
                        item.path = '/chat/' + this.props.threads.filter(t => t.title === 'announcements')[0].id;
                        if(this.props.user.user.Profile){
                            this.props.threads.filter(t => t.title === 'announcements')[0].Messages.map(m => {
                                if(m.seenBy){
                                    if(Object.keys(m.seenBy).indexOf(this.props.user.user.Profile.id) === -1){
                                        badgeIcon = 'zmdi zmdi-circle text-danger';
                                    }
                                }
                            })
                        }
                    }else{
                        item.path = '/chat/';
                    }
                }else{
                    item.path = '/chat/';
                }
            }else if(item.title === 'Messages'){
                if(this.props.threads){
                    if(this.props.threads.filter(t => !t.title).length > 0){
                        
                        if(this.props.profile){
                            this.props.threads.filter(t => !t.title).map(thread => {
                                if(thread.unread){
                                    badgeIcon = 'zmdi zmdi-circle text-danger';
                                }
                            })
                        }
                    }else{
                        item.path = '/chat/';
                    }
                }else{
                    item.path = '/chat/';
                }
            }

            if (shouldShow) {
                return (
                    <li
                        key={`parentItem_${catId}_${index}`}
                        onClick={() => {
                            if (item.title === "Logout") {
                                this.props.onLogout()
                            }else if(item.title === 'Course Syllabus'){
                                
                                if($("#SyllabusPane").hasClass("acitveSyllabusPane")){
                                    $("#SyllabusPane").toggleClass("acitveSyllabusPane");
                                    $('#content-container').removeClass('blur');
                                }else{
                                    if(this.props.courseUser[0]){
                                        if(this.props.syllabus.lastUpdated){
                                            if(moment().diff(moment(this.props.syllabus.lastUpdated), 'minutes') >= 60){
                                                this.props.getSyllabus(this.props.courseUser[0].id);
                                            }
                                        }
                                        
                                    }
                                    $("#SyllabusPane").toggleClass("acitveSyllabusPane");
                                    $('#content-container').addClass('blur');
                                }
                                
                               
                            }
                        }}
                    >
                        {
                            item.path ?
                                <Link
                                    className={
                                        item.expanded
                                            ? "active-item-sidebar"
                                            : null
                                    }
                                    to={item.path}
                                    
                                    >
                                    <i className={item.icon}/>
                                    {badgeIcon ? 
                                        <i className={`${badgeIcon} sidebar-badge`} />
                                    : null}
                                    <span>{item.title}</span>
                                    <i className="fa fa-angle-right pull-right"/>
                                </Link> :
                                <a
                                    className={
                                        item.expanded
                                            ? "active-item-sidebar"
                                            : null
                                    }
                                    onClick={() => {
                                        let {sidebar} = this.state;
                                        sidebar[catId].items[index].expanded = !sidebar[catId].items[index].expanded;
                                        this.setState({sidebar});
                                    }}
                                >
                                    <i className={item.icon}/>
                                    {badgeIcon ? 
                                        <i className={`${badgeIcon} sidebar-badge`} />
                                    : null}
                                    <span>{item.title}</span>
                                    <i className="fa fa-angle-right pull-right"/>
                                </a>
                        }

                        {item.items &&
                            <ul className={
                                "sidebar_submenu treeview-menu treeview-menu-expanded"
                            }>
                                <SlideDown className='my-dropdown-slidedown'>
                                    {
                                        item.items &&
                                        this.renderCategorySubItems(`${catId}_${index}`, item.items)
                                    }
                                </SlideDown>
    
                            </ul>
                        }
                    </li>
                )
            }
        });
    }

    renderCategorySubItems = (parId, items) => (
        items.map((item, index) => {
            
            if(this.props.profile.CourseUser){

            if(item && this.props.profile.CourseUser[0]) {
                try{
                    return item.map(c => {
                        let subject = this.props.profile.CourseUser[0].Course.CourseSubject.filter(s => s.id == c);
                        let current = this.props.profile.CourseUser[0].currentSubject == c;
                        let complete = this.props.profile.CourseUser[0].completedSubjects.filter(s => s.id == c).length > 0;
    
                        let icon = "zmdi zmdi-lock";
    
                        if (current) {
                            icon = "zmdi zmdi-chevron-right"
                        } else if (complete) {
                            icon = "zmdi zmdi-check";
                        }
    
                        return (
                            <li key={`childItem_${index}${c}`}>
                                <Link to={`/video/${subject[0].id}`}>
                                    {c.icon ?
                                        <i className={icon}/>
                                        :
                                        <i className={icon}/>
    
                                    }
    
                                    {subject[0].name}
                                </Link>
                            </li>
                        )
                    })
                }catch(err){
                }
            }
            }


        }

        )
    );

    renderSearchForm = () => (
        <form
            action="#"
            method="get"
            className="sidebar-form"
        >
            <div className="input-group">
                <input
                    type="text"
                    name="q"
                    className="form-control"
                    placeholder="Search..."
                    onChange={this.searchInSidebar}
                />
                <span className="input-group-btn">
                    <button
                        type='submit'
                        name='search'
                        id='search-btn'
                        className="btn btn-flat"
                    >
                        <i className="fa fa-search"/>
                    </button>
                </span>
            </div>
        </form>
    );

    render() {
        return (
            <div
                className="main-sidebar"

            >
                <section className="sidebar">
                    {this.renderUserInfo()}
                    {this.renderSearchForm()}
                    {this.renderCategories()}
                </section>
            </div>
        );
    }

}

Sidebar.propTypes = {
    sidebar: PropTypes.array.isRequired,
    onLoad: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
    setExpandedOnHover: PropTypes.func.isRequired,
    setCollapsedOnHover: PropTypes.func.isRequired,
    handleClickMenuItem: PropTypes.func.isRequired
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Generals/Sidebar.js